import React, { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { eventJournalConsumerAtom } from '../../atoms/event-journal-atoms';
import { studioConfigAtom } from '../../atoms/studio-store';
import { BackendSyncDelegate } from '../backend-sync-delegate';
import { EventJournalConsumer } from '../event-journal-consumer';
import { NoOpSyncDelegate } from '../no-op-sync-delegate';
type PropsT = {
  children: React.ReactNode;
};
export const EventJournalConsumerInitializer = ({
  children
}: PropsT) => {
  const setEventJournalConsumer = useSetAtom(eventJournalConsumerAtom);
  const studioConfig = useAtomValue(studioConfigAtom);
  useEffect(() => {
    const isWindowed = studioConfig?.mode === 'windowed';
    const delegate = isWindowed ? new BackendSyncDelegate(studioConfig.syncAnnotations) : new NoOpSyncDelegate();
    const consumer = new EventJournalConsumer(delegate);
    if (isWindowed) {
      consumer.runForTaskID(studioConfig.taskKey);
    }
    setEventJournalConsumer(consumer);
    const onBeforeUnload = () => consumer.stop();
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      consumer.dispose();
      setEventJournalConsumer(null);
    };
  }, [setEventJournalConsumer, studioConfig]);
  return <>{children}</>;
};